/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class ConfigurationTemplateDormerOverhangDto {
    cheeksOverhang: number;
    stubbedSouthOverhang: number;
    stubbedEastOverhang: number;
    stubbedWestOverhang: number;
}
